import React from 'react'

const CARDS = [
  {
    icon: 'bi-person-raised-hand',
    title: 'Volunteer',
    text: 'Share your skills, time, and passion to support our programs in schools and communities.',
    cta: 'Become a Volunteer',
    href: '/contact',
    highlight: false,
  },
  {
    icon: 'bi-building',
    title: 'Partner With Us',
    text: 'Collaborate with SISDI as a school, organisation, or sponsor to expand our reach and impact.',
    cta: 'Become a Partner',
    href: '/contact',
    highlight: false,
  },
  {
    icon: 'bi-heart-fill',
    title: 'Donate',
    text: 'Your financial support helps us deliver quality football and education programs to more children.',
    cta: 'Donate Now',
    href: '/donate',
    highlight: true,
  },
]

export default function GetInvolvedSection({ fadeClass = '' }) {
  return (
    <section className={`section ${fadeClass}`} style={{ background: 'var(--color-light)' }}>
      <div className="container">
        <div className="section-header fade-in">
          <span className="eyebrow">Take Action</span>
          <h2>Get <span className="text-accent">Involved</span></h2>
          <div className="section-divider"></div>
          <p style={{ maxWidth: '580px', margin: '1.5rem auto 0' }}>
            There are many ways to support SISDI&apos;s mission and help shape the future
            of children across Africa. Every action counts.
          </p>
        </div>

        <div className="grid-3 fade-in-stagger">
          {CARDS.map((c, i) => (
            <div className={`involve-card${c.highlight ? ' highlight' : ''}`} key={i}>
              <div className={`icon-circle${c.highlight ? '' : ''}`}
                style={c.highlight ? { background: 'var(--color-accent)', color: 'var(--color-dark)' } : {}}>
                <i className={`bi ${c.icon}`}></i>
              </div>
              <h4 style={{ marginBottom: '0.75rem' }}>{c.title}</h4>
              <p>{c.text}</p>
              <a
                href={c.href}
                className={`btn ${c.highlight ? 'btn-accent' : 'btn-secondary'}`}
                style={{ marginTop: '1.5rem' }}
              >
                {c.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
